<template>
  <div class="col-sm-4">
    <div :class="'card ' + orientation + (this.goto ? ' clickable' : '')" v-on:click="open()">
      <div class="card-body">
        <div class="card-body-icon" v-if="icon">
          <i :class="icon"></i>
        </div>
        <div v-else>
          <img :src="'/images/'+image" width="120px" alt="image_description"/>
        </div>
        <br/>
        <h3>{{ title }}</h3>
        <p class="card-text">{{ text }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["orientation", "icon", "title", "text", "image", "goto"],

  methods: {
    open() {
      if (this.goto) {
        if (this.goto.startsWith("http://") || this.goto.startsWith("https://")) {
          window.open(this.goto, '_blank').focus()
        } else {
          this.$router.push(this.goto)
        }
      }
    }
  }
}
</script>

<style scoped>
.card-body-icon {
  color: #fff;
  font-size: 64px;
  width: 100%
}

.card {
  color: #f7f7f7;
  background-color: #012f2d;
  margin-right: 0;
  margin-left: auto;
  min-height: 310px;
  margin-bottom: 40px;
  display: flex;
  flex-direction: row;
  align-items: stretch
}

.clickable {
  cursor: pointer;
  transition-duration: 2s;
}

.clickable:hover {
  background-color: #198754 !important;
}

.left.clickable:hover {
  box-shadow: -0.3em 0.3em 0 0 rgb(1, 47, 45);
}

.middle.clickable:hover {
  box-shadow: 0 0.3em 0 0 rgb(1, 47, 45);
}

.right.clickable:hover {
  box-shadow: 0.3em 0.3em 0 0 rgb(1, 47, 45);
}

.left {
  box-shadow: -0.3em 0.3em 0 0 #33e091;
}

.middle {
  box-shadow: 0 0.3em 0 0 #33e091;
}

.right {
  box-shadow: 0.3em 0.3em 0 0 #33e091;
}


.topleft {
  box-shadow: -0.3em -0.3em 0 0 #33e091;
}

.topmiddle {
  box-shadow: 0 -0.3em 0 0 #33e091;
}

.topright {
  box-shadow: 0.3em -0.3em 0 0 #33e091;
}

.card-body {
  min-height: 350px;
}

@media screen and (max-width: 1600px) {
  .card-body {
    min-height: 400px;
  }
}

@media screen and (max-width: 1000px) {
  .card-body {
    min-height: 500px;
  }
}

@media screen and (max-width: 780px) {
  .card-body {
    min-height: 600px;
    padding: 1rem 0;
  }
}

@media screen and (max-width: 575px) {
  .card-body {
    min-height: unset;
  }
}

@media screen and (max-width: 1080px) {

  .left {
    box-shadow: 0 0.3em 0 0 #33e091;
  }

  .right {
    box-shadow: 0 0.3em 0 0 #33e091;
  }

  .topleft {
    box-shadow: 0 0.3em 0 0 #33e091;
  }

  .topright {
    box-shadow: 0 0.3em 0 0 #33e091;
  }

  .topmiddle {
    box-shadow: 0 0.3em 0 0 #33e091;
  }
}
</style>